export * from "./brand";
export * from "./brand-color";
export * from "./directional";
export * from "./duotone";
export * from "./state";
export * from "./utility";
export * as brandIcons from "./brand";
export * as brandColorIcons from "./brand-color";
export * as directionalIcons from "./directional";
export * as duotoneIcons from "./duotone";
export * as stateIcons from "./state";
export * as utilityIcons from "./utility";
//# sourceMappingURL=index.js.map